var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "payment-methods-modal",
      attrs: { visible: _vm.value },
      on: {
        "on-close": function($event) {
          return _vm.$emit("input", false)
        }
      }
    },
    [
      _vm.loading
        ? _c("ui-loader", {
            staticClass: "payment-methods-modal__loader",
            attrs: { size: "64" }
          })
        : _vm._e(),
      _c("div", { staticClass: "payment-methods-modal__title" }, [
        _vm._v("\n    Выберите способ оплаты\n  ")
      ]),
      _c(
        "div",
        { staticClass: "payment-methods-modal__wrapper" },
        _vm._l(_vm.paymentMethods, function(method) {
          return _c("payment-method", {
            key: method.value,
            attrs: { info: method, disabled: _vm.loading },
            nativeOn: {
              click: function($event) {
                return _vm.$emit("select", method)
              }
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }